// import React from 'react';
// import classNames from 'classnames';
// import PropTypes from 'prop-types';
// import { useConfig } from '../ConfigProvider';

// const Card = React.forwardRef((props, ref) => {
//   const { cardBordered } = useConfig();

//   const { children, className, clickable, onClick, bordered = cardBordered || false, bodyClass, header, headerClass, headerBorder, headerExtra, footer, footerClass, footerBorder, ...rest } = props;

//   const cardClass = classNames('card', className, bordered ? `card-border` : `card-shadow`, clickable && 'cursor-pointer user-select-none');

//   const cardBodyClasss = classNames('card-body', bodyClass);
//   const cardHeaderClass = classNames('card-header', headerBorder && 'card-header-border', headerExtra && 'card-header-extra', headerClass);
//   const cardFooterClass = classNames('card-footer', footerBorder && `card-footer-border`, footerClass);

//   const renderHeader = () => {
//     if (typeof header === 'string') {
//       return <h4>{header}</h4>;
//     }
//     return <>{header}</>;
//   };

//   const onCardClick = (e) => {
//     onClick?.(e);
//   };

//   return (
//     <div className={cardClass} ref={ref} {...rest} onClick={onCardClick}>
//       {header && (
//         <div className={cardHeaderClass}>
//           {renderHeader()}
//           {headerExtra && <span>{headerExtra}</span>}
//         </div>
//       )}
//       <div className={cardBodyClasss}>{children}</div>
//       {footer && <div className={cardFooterClass}>{footer}</div>}
//     </div>
//   );
// });

// Card.propTypes = {
//   bordered: PropTypes.bool,
//   clickable: PropTypes.bool,
//   bodyClass: PropTypes.string,
//   headerClass: PropTypes.string,
//   footerClass: PropTypes.string,
//   headerBorder: PropTypes.bool,
//   footerBorder: PropTypes.bool,
//   header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
//   footer: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
//   onClick: PropTypes.func,
// };

// Card.defaultProps = {
//   clickable: false,
//   headerBorder: true,
//   footerBorder: true,
// };

// export default Card;

import classNames from 'classnames';
import React, { forwardRef, useMemo } from 'react';
import { useConfig } from '../ConfigProvider';

interface IProps {
  bordered?: boolean;
  clickable?: boolean;
  bodyClass: string;
  headerClass: string;
  footerClass: string;
  headerBorder?: boolean;
  footerBorder?: boolean;
  isCardDisabled?: boolean;
  header: React.ReactNode | string;
  footer: React.ReactNode | string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  headerExtra: boolean;
  className: string;
}

const Card: React.FC<IProps> = forwardRef<HTMLDivElement, IProps>(({ children, className, clickable = false, onClick, bordered: propsBordered, bodyClass, header, headerClass, headerExtra, footer, footerClass, headerBorder = true, footerBorder = true, isCardDisabled = false, ...rest }, ref) => {
  const { cardBordered } = useConfig();
  const bordered = useMemo(() => (propsBordered ? propsBordered : cardBordered), [propsBordered, cardBordered]);

  const cardClass = classNames('card', className, bordered ? `card-border` : `card-shadow`, clickable && 'cursor-pointer user-select-none', 'test');
  const cardBodyClasss = classNames('card-body', bodyClass);
  const cardHeaderClass = classNames('card-header', headerBorder && 'card-header-border', headerExtra && 'card-header-extra', headerClass);
  const cardFooterClass = classNames('card-footer', footerBorder && `card-footer-border`, footerClass);

  const cardClassDisable = classNames('', className, clickable && 'cursor-pointer user-select-none');
  const cardBodyClasssDisable = classNames(bodyClass);
  const cardHeaderClassDisable = classNames('', headerBorder && 'card-header-border', headerExtra && 'card-header-extra', headerClass);
  const cardFooterClassDisable = classNames('', footerBorder && `card-footer-border`, footerClass);

  return (
    <>
      {isCardDisabled ? (
        <div className={cardClassDisable} ref={ref} {...rest} onClick={onClick}>
          {header && (
            <div className={cardHeaderClassDisable}>
              {typeof header === 'string' ? <h4>{header}</h4> : <>{header}</>}
              {headerExtra && <span>{headerExtra}</span>}
            </div>
          )}
          <div className={cardBodyClasssDisable}>{children}</div>
          {footer && <div className={cardFooterClassDisable}>{footer}</div>}
        </div>
      ) : (
        <div className={cardClass} ref={ref} {...rest} onClick={onClick}>
          {header && (
            <div className={cardHeaderClass}>
              {typeof header === 'string' ? <h4>{header}</h4> : <>{header}</>}
              {headerExtra && <span>{headerExtra}</span>}
            </div>
          )}
          <div className={cardBodyClasss}>{children}</div>
          {footer && <div className={cardFooterClass}>{footer}</div>}
        </div>
      )}
    </>
  );
});

export default Card;
